import { Box, Image, Link } from '@chakra-ui/react';

import { IPortfolioCompany } from '../companies-list/companies';

export interface ICompanyLogoProps {
  company: IPortfolioCompany;
}

export const CompanyLogo = ({ company }: ICompanyLogoProps) => {
  const { logo, name, href, description } = company;

  if (logo === null) return null;

  return (
    <Link href={href} target="_blank">
      <Box
        border="1px"
        borderRadius="4px"
        borderColor="transparent"
        borderStyle="solid"
        padding="8px"
        display="flex"
        textAlign="center"
        justifyContent="center"
        alignItems="center"
        h={{ base: 'full', md: '256px' }}
        w={{ base: 'full', md: '256px' }}
        maxH={{ base: '148px', md: '256px' }}
        filter="grayscale(100%)"
        opacity={0.7}
        transition="all 200ms ease-in-out"
        _hover={{
          filter: 'none',
          opacity: 1,
        }}
      >
        <Image
          src={logo}
          alt={name}
          maxH="100%"
          maxW="100%"
          title={description}
        />
      </Box>
    </Link>
  );
};
